import { getCurrentUserInfo } from '@loggi/driver-authentication';
import {
  useFeatureSwitch,
  useRemoteConfig
} from '@loggi/firebase-feature-switches';
import featureSwitches from 'operations/feature-switches';
import { blockedCompanyTypes } from 'view/pages/home/constants';

export const defaultFeedback = {
  title: 'Aplicativo bloqueado',
  message: 'Entre em contato com a base para mais informações sobre seu acesso.'
};

const driverHasBlockedCompanyType = driver => {
  return blockedCompanyTypes.includes(driver?.companyType);
};

const isBaseOrLmcBlocked = driver => {
  // All the "Leve" bases are blocked by "enableAccessBlockingLeve" Feature Switch
  // but the logic to block by routing code remains
  // because accessBlocking may contain any Loggi bases.
  return baseItem => {
    const base = baseItem?.toLowerCase();
    const isBlocked = base === driver?.routingCode?.toLowerCase();
    const isLmcBlocked = base === driver?.lmcIdentification?.toLowerCase();
    return isBlocked || isLmcBlocked;
  };
};

export const useIsAccessBlocked = driverInfo => {
  const driver = driverInfo ?? getCurrentUserInfo();
  const accessBlocking = useRemoteConfig(featureSwitches.accessBlocking, {
    users: [],
    bases: [],
    feedback: defaultFeedback
  });
  const enableAccessBlockingLeve = useFeatureSwitch(
    featureSwitches.enableAccessBlockingLeve
  );

  if (!driver) {
    return {
      isDriverAccessBlocked: false,
      feedback: accessBlocking.feedback
    };
  }

  if (enableAccessBlockingLeve && driverHasBlockedCompanyType(driver)) {
    return {
      isDriverAccessBlocked: true,
      feedback: accessBlocking.feedback
    };
  }

  const foundDriver = accessBlocking?.users?.find(
    blocked => blocked.id === driver?.id
  );

  if (foundDriver) {
    return {
      isDriverAccessBlocked: foundDriver?.status !== 'allowed',
      feedback: accessBlocking.feedback
    };
  }

  const isDriverBaseOrLmcBlocked = accessBlocking?.bases?.some(
    isBaseOrLmcBlocked(driver)
  );

  return {
    isDriverAccessBlocked: isDriverBaseOrLmcBlocked,
    feedback: accessBlocking.feedback
  };
};
